/**
 * Convert a SCREAMING_SNAKE_CASE enum value into a human-readable label.
 *
 *   formatEnumLabel('REQUIRE_APPROVAL') === 'Require Approval'
 */
export const formatEnumLabel = (value: string): string =>
    value
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
